import * as React from "react";
import type { SVGProps } from "react";
const SvgAddressBook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="M12.086 11.152a2.812 2.812 0 1 0-2.922 0 4.97 4.97 0 0 0-2.539 1.786.312.312 0 1 0 .5.374 4.374 4.374 0 0 1 7 0 .313.313 0 0 0 .5-.374 4.97 4.97 0 0 0-2.54-1.786M8.437 8.75a2.187 2.187 0 1 1 4.375 0 2.187 2.187 0 0 1-4.374 0m7.813-6.562H5a.937.937 0 0 0-.937.937v2.188H2.5a.312.312 0 1 0 0 .625h1.563v3.75H2.5a.312.312 0 1 0 0 .624h1.563v3.75H2.5a.312.312 0 1 0 0 .626h1.563v2.187a.937.937 0 0 0 .937.938h11.25a.94.94 0 0 0 .938-.938V3.125a.94.94 0 0 0-.938-.937m.313 14.687a.313.313 0 0 1-.313.313H5a.31.31 0 0 1-.312-.313V3.125A.31.31 0 0 1 5 2.813h11.25a.313.313 0 0 1 .313.312z" />
  </svg>
);
export default SvgAddressBook;
